module.exports = __webpack_public_path__ + "static/media/plus.8cd9785f.svg";